'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.scroll = exports.ScrollService = exports.Direction = void 0;
var Direction;
(function (Direction) {
    Direction[Direction["NONE"] = 0] = "NONE";
    Direction[Direction["DOWN"] = 1] = "DOWN";
    Direction[Direction["UP"] = 2] = "UP";
})(Direction = exports.Direction || (exports.Direction = {}));
var ScrollService = /** @class */ (function () {
    function ScrollService() {
        var _this = this;
        this.rootElement = document.body;
        this.isScrollingEnabled = true;
        this.lastTouchPosition = 0;
        this.setLastTouchLocation = function (event) {
            _this.lastTouchPosition = event.touches[0].clientY;
        };
        this.preventScrolling = function (event) {
            if (!event.cancelable) {
                return;
            }
            var direction = _this.getDirection(event);
            if (event.composedPath) {
                // Follow slotted events up the tree.
                var scrollable = event.composedPath().some(function (element) {
                    return _this.isScrollable(element, direction);
                });
                if (!scrollable) {
                    event.preventDefault();
                }
                return;
            }
            var currTarget = event.target;
            while (currTarget instanceof Element) {
                if (_this.isScrollable(currTarget, direction)) {
                    event.preventDefault();
                    return;
                }
                currTarget = currTarget.parentElement;
            }
        };
    }
    /**
     * Listens for scroll events on the passed through element and
     * calls handler.
     * @param handler Called whenever the user scrolls
     * @param elementOrWindow The element (or window) to scroll
     * @returns Disposal method to destroy the scroll listener.
     */
    ScrollService.prototype.onScroll = function (handler, elementOrWindow) {
        if (elementOrWindow === void 0) { elementOrWindow = window; }
        elementOrWindow.addEventListener('scroll', handler, { passive: true });
        return function () {
            elementOrWindow.removeEventListener('scroll', handler);
        };
    };
    ScrollService.prototype.scrollTo = function (element, useOffset) {
        if (useOffset === void 0) { useOffset = false; }
        if (!useOffset) {
            element.scrollIntoView({
                behavior: 'smooth',
            });
            return;
        }
        var parent = exports.scroll.findScrollableParent(element);
        if (parent) {
            var contentElement = document.getElementById('content');
            var offsetTop = parseInt(getComputedStyle(contentElement).getPropertyValue('padding-top'), 10) || 0;
            var top_1 = element.getBoundingClientRect().top - offsetTop;
            parent.scrollBy({
                top: top_1,
                behavior: 'smooth',
            });
        }
    };
    /**
     * Scrolls back to the top of the document
     */
    ScrollService.prototype.scrollToTop = function () {
        // TODO: Animate
        window.scrollTo(0, 0);
    };
    /**
     * Sets the root element that scroll events should be prevented on when
     * modals are open.
     * @param rootElement The root element to ignore scroll events for
     */
    ScrollService.prototype.setRootElement = function (rootElement) {
        this.rootElement = rootElement;
    };
    /**
     * Disables body/set root element scrolling
     */
    ScrollService.prototype.disableScrolling = function () {
        if (!this.isScrollingEnabled) {
            return;
        }
        this.lastTouchPosition = 0;
        this.isScrollingEnabled = false;
        // Mobile devices need to prevent actions that cause scrolling
        document.body.classList.add('no-scroll');
        window.addEventListener('wheel', this.preventScrolling, {
            passive: false,
        });
        window.addEventListener('touchstart', this.setLastTouchLocation, {
            passive: false,
        });
        window.addEventListener('touchmove', this.preventScrolling, {
            passive: false,
        });
    };
    /**
     * Re-enables body/set root element scrolling
     */
    ScrollService.prototype.enableScrolling = function () {
        if (this.isScrollingEnabled) {
            return;
        }
        this.lastTouchPosition = 0;
        this.isScrollingEnabled = true;
        document.body.classList.remove('no-scroll');
        window.removeEventListener('wheel', this.preventScrolling);
        window.removeEventListener('touchstart', this.setLastTouchLocation);
        window.removeEventListener('touchmove', this.preventScrolling);
    };
    /**
     * Finds the nearest parent element that is actually scrollable
     * @param element
     */
    ScrollService.prototype.findScrollableParent = function (element) {
        var currTarget = element.parentElement;
        while (currTarget) {
            if (this.isScrollable(currTarget, Direction.DOWN) ||
                this.isScrollable(currTarget, Direction.UP)) {
                return currTarget;
            }
            var shadowRoot = currTarget.getRootNode();
            currTarget =
                currTarget.parentElement ||
                    (shadowRoot ? shadowRoot.host : null);
        }
        return window;
    };
    ScrollService.prototype.getDirection = function (event) {
        // May have to account for horizontal scrolling here.
        var changedTouches = event.changedTouches;
        if (changedTouches) {
            var currentPos = changedTouches[0].clientY;
            var isUp = this.lastTouchPosition < currentPos;
            return isUp ? Direction.UP : Direction.DOWN;
        }
        var deltaY = event.deltaY;
        return deltaY && deltaY > 0 ? Direction.DOWN : Direction.UP;
    };
    ScrollService.prototype.isScrollable = function (element, direction) {
        if (element === this.rootElement ||
            element === document.scrollingElement) {
            return false;
        }
        if (element instanceof Window) {
            return false;
        }
        if (element instanceof Element) {
            var scrollTop = element.scrollTop, scrollHeight = element.scrollHeight, clientHeight = element.clientHeight;
            var hasScrollbar = scrollHeight >= clientHeight;
            if (!hasScrollbar) {
                return false;
            }
            var atTop = scrollTop <= 0;
            var atBottom = scrollHeight - scrollTop === clientHeight;
            var isUp = direction === Direction.UP;
            var isDown = direction === Direction.DOWN;
            var atBounds = (atTop && isUp) || (atBottom && isDown);
            if (atBounds) {
                return false;
            }
            // Check if the overflow content is visible - expensive check last.
            var styles = getComputedStyle(element);
            return ['hidden', 'visible'].indexOf(styles.overflowY) === -1;
        }
        return false;
    };
    return ScrollService;
}());
exports.ScrollService = ScrollService;
exports.scroll = new ScrollService();
